// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleGroup_container__2757f","heading":"TitleGroup_heading__CFVGW","title":"TitleGroup_title__3uZ21","subtitle":"TitleGroup_subtitle__18HWa"};